import type { Country, JobItem, JobPageItem, SavedJobItem } from '@types'

import seoUrlPathEncode from './seo-url-path-encode'

type JobUrlBuilderArg = {
  address: { city?: string }
  microRole?: string | null
  contractType?: string
  title?: string
  id?: string
}

export default function jobUrlBuilder(
  element: JobUrlBuilderArg | JobItem | SavedJobItem | JobPageItem,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  country: Country,
): string {
  const role = element.microRole || element.contractType
  let url = `/jobs/${seoUrlPathEncode(element.address?.city, 'location')}/`
  url += seoUrlPathEncode(role, 'role')
  url += `/${seoUrlPathEncode(element.title, 'title')}`
  url += `-${element.id}`

  return url.replace(new RegExp('//', 'g'), '/')
}
